import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { post } from '../../util/request';
import backIcon from '../../assets/icon/arrow.png';
import headerImg from '../../assets/image/detail/novip.jpg';
import memberImg from '../../assets/image/detail/member.png';
import fitImg from '../../assets/image/detail/fit.png';
import right1Img from '../../assets/image/detail/right1.png';
import right2Img from '../../assets/image/detail/right2.png';
import right3Img from '../../assets/image/detail/right3.png';
import problemImg from '../../assets/image/detail/problem.jpg';
// import commentImg from '../../assets/image/detail/comment.png';
import { appId } from '../../constants';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import user from '../../objects/user/model';

const Group = observer(() => {
  const [haveParchased1, setHaveParchased1] = useState<boolean>(false);
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);

  const title = query.get('title');
  const price = query.get('price');

  useEffect(() => {
    if (params.id) {
      user
        .fetchIsPurchased(params.id)
        .then((v) => setHaveParchased1(!!v?.purchased));
    }
  }, []);

  const haveParchased = user.purchasedList.find((item) => item === params.id);

  const handlePay = async () => {
    try {
      // 1. 调用下单接口
      const data = await post('payment/create', {
        packageId: params.id, // '244fc4da-08a7-11f0-83df-8a79bd49342d', // 替换为实际套餐ID
        appId,
      });

      // 2. 调起微信支付
      if (typeof WeixinJSBridge === 'undefined') {
        alert('请在微信中打开此页面');
        return;
      }

      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: data.appId,
          timeStamp: data.timeStamp,
          nonceStr: data.nonceStr,
          package: data.package,
          signType: data.signType,
          paySign: data.paySign,
        },
        function (res) {
          console.log('支付结果:', res);
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            alert('支付成功');
            navigate('/qrcode');
          } else {
            alert('支付失败: ' + res.err_msg);
          }
        },
      );
    } catch (error: any) {
      console.error('支付错误:', error);
      alert('支付出错: ' + error.message);
    }
  };
  const handleCheck = () => {
    navigate('/qrcode');
  };
  const goToFemale = () => {
    navigate('/female');
  };
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img src={backIcon} onClick={() => navigate(-1)} />
        <p>{title}</p>
      </div>

      <div className={styles.body}>
        <div className={styles.intro}>
          <img src={headerImg} />
          <p>{title}</p>
        </div>

        <div className="p-2" />
        <img src={memberImg} />
        <div className="p-10" />
        <img src={fitImg} />
        <div className="p-4" />
        <img src={right1Img} />
        <div className="p-2" />
        <img src={right2Img} />
        <div className="p-2" />
        <img src={right3Img} />
        <div className="p-10" />
        <img src={problemImg} />
        <div className="p-10" />
        {/* <img src={commentImg} /> */}
      </div>
      <div
        className={
          styles.footer + ' fixed bottom-0 left-0 right-0 p-4 bg-white border-t'
        }
      >
        {haveParchased || haveParchased1 ? (
          <button
            onClick={handleCheck}
            id="payButton"
            className="join-btn w-full py-3 rounded-xl text-white font-medium text-lg"
          >
            已支付查看二维码
          </button>
        ) : (
          <button
            onClick={handlePay}
            id="payButton"
            className="join-btn w-full py-3 rounded-xl text-white font-medium text-lg"
          >
            男生入群 ¥{price}
          </button>
        )}
        {haveParchased || haveParchased1 ? null : (
          <button
            onClick={goToFemale}
            id="payButton"
            className="join-btn w-full py-3 rounded-xl text-white font-medium text-lg"
          >
            女生免费入群
          </button>
        )}
      </div>
    </div>
  );
});

export default Group;
